import React, { useState } from 'react';
import { StyledContainer, StyledGrid, OutsideLink, StyledLink, Line, Bottom } from './Footer.js';


import FooterLogo from "../../assets/cangoo-logo.png"

import LogoFaceOn from '../../assets/cangoo-fb-on.png'
import LogoFaceOff from '../../assets/cangoo-fb-off.png'

import LogoInstaOn from '../../assets/cangoo-ig-on.png'
import LogoInstaOff from '../../assets/cangoo-ig-off.png'

import LogoLinkedinOn from '../../assets/cangoo-ld-on.png'
import LogoLinkedinOff from '../../assets/cangoo-ld-off.png'

import IconEmail from '../../assets/rodape-icon-email.png'
import IconTel from '../../assets/rodape-icon-telefone.png'
import IconWhats from '../../assets/rodape-icon-wp.png'

import WhatsFloat from '../../assets/botao-icon-whatsapp-75x75.png'



import { Grid } from '@mui/material';

import CustomLink from '../CustomLink/CustomLink.jsx';

export function Footer() {
    const [isFacebookHovered, setIsFacebookHovered] = useState(false);
    const [isInstaHovered, setIsInstaHovered] = useState(false);
    const [isLinkedinHovered, setIsLinkedinHovered] = useState(false);

    const handleWhatsappClick = () => {
      window.open('https://wa.me/554833645744', '_blank');
    };


    const handleMouseOverFace = () => {
        setIsFacebookHovered(true);
      };

    const handleMouseOutFace = () => {
        setIsFacebookHovered(false);
      };
      
    
      const handleMouseOverInsta = () => {
        setIsInstaHovered(true);
      };

      const handleMouseOutInsta = () => {
        setIsInstaHovered(false);
      };

      const handleMouseOverLinkedin = () => {
        setIsLinkedinHovered(true);
      };

      const handleMouseOutLinkedin = () => {
        setIsLinkedinHovered(false);
      };

    return (
      <>

<StyledContainer maxWidth="xg">
      <Grid container>
      <StyledGrid item xs={12} sm={12}  md={4} xl={4}>

           <div className='logo'>
           <CustomLink to="/"><img src={FooterLogo} alt="Logo" /></CustomLink>
           </div>
        </StyledGrid>



        <StyledGrid item xs={12} sm={12}  md={2} xl={2}>
        <h1>A CANGOO</h1>
      
      <div>
      <ul>
      <li><StyledLink to="/sobre"><span>Sobre Nós</span></StyledLink></li>
      <li><StyledLink to="/faq"><span>Perguntas Frequentes</span></StyledLink></li>
      <li><StyledLink to="/cotacao"><span>Cotação de Frete</span></StyledLink></li>
      <li><StyledLink to="/contato"><span>Contato</span></StyledLink></li>
      <li className='top'>
        <OutsideLink className='link'  target="_blank" onClick={handleWhatsappClick}>Rastreio Online</OutsideLink>
      </li>

      <li>
        <OutsideLink className='link' target="_blank" href="https://cangooexpress.brudam.com.br/site/">Área de Cliente</OutsideLink>
      </li>

      </ul>   
      </div>
        </StyledGrid>



        <StyledGrid item xs={12} sm={12}  md={3} xl={3}>
        <h1>ENDEREÇO</h1>

        <p>
        Rua Antônio Filomeno, 110<br/>
        Bairro Bom Abrigo.<br/>
        Florianópolis - SC<br/>
        88085-355
        </p>

        <h1>CONTATOS</h1>
         
         <ul className='contatos'>
            <li><OutsideLink onClick={handleWhatsappClick}><span><img alt='' src={IconWhats}/> +55 48 3364.5744</span></OutsideLink></li>
            <li><OutsideLink href="tel:483364.5744"><span><img alt='' src={IconTel}/> +55 48 3364.5744</span></OutsideLink></li>
            <li><OutsideLink  href="mailto:contato@vaidecangoo.com.br"><span><img alt='' src={IconEmail}/> contato@vaidecangoo.com.br</span></OutsideLink></li>
         </ul>
        </StyledGrid>



        <StyledGrid item xs={12} sm={12}  md={3} xl={2}>
        <h1>REDES SOCIAIS</h1>
       
       <OutsideLink href="https://www.facebook.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverFace} onMouseOut={handleMouseOutFace}>
              <img style={{ width: 30 }} src={isFacebookHovered ? LogoFaceOn : LogoFaceOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.instagram.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverInsta} onMouseOut={handleMouseOutInsta}>
              <img style={{ width: 30, marginRight:'1.4rem', marginLeft: '1.4rem' }} src={isInstaHovered ? LogoInstaOn : LogoInstaOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.linkedin.com/company/vaidecangoo" target="_blank" onMouseOver={handleMouseOverLinkedin} onMouseOut={handleMouseOutLinkedin}>
              <img style={{ width: 30 }} src={isLinkedinHovered ? LogoLinkedinOn : LogoLinkedinOff} border="0" alt=''/>
            </OutsideLink>
        </StyledGrid>
      </Grid>

      <Grid container>
      <StyledGrid item xs={12} sm={12}  md={12}>
        <Line/>
      <Bottom>
      <ul>
     <li> 
          <StyledLink to="/politica">
     <span className='politica'>Política de Privacidade</span>
          </StyledLink>
     </li>
      </ul>
      </Bottom>
      </StyledGrid>
      </Grid>

         <img className='whats-float' src={WhatsFloat} alt="" onClick={handleWhatsappClick} />

</StyledContainer>

     </>
    )
  }